import type { Withdrawal } from '../types/affiliate.types';

/** The ID column: the bank's transfer ref when there is one, else the start of the id. */
export const withdrawalCode = (withdrawal: Withdrawal) =>
  withdrawal.payout_reference ?? withdrawal.id.slice(0, 8).toUpperCase();
